export default function nameString(lastName, firstName, middleName){
    const result = []

    if(lastName){
        result.push(lastName)
    }

    if(firstName){
        result.push(firstName)
    }

    if(middleName){
        result.push(middleName)
    }

    return result.join(" ")
}
